import { classNames } from "./classNames.ts";

export function Switch({
  checked,
  onChange,
  label,
}: {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label: string;
}) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      onClick={() => onChange(!checked)}
      className={
        "group flex items-center gap-2 text-sm text-gray-500 hover:text-gray-900 focus:outline-none"
      }
    >
      <span>{label}</span>
      <span
        className={classNames(
          "inline-flex h-5 w-9 flex-shrink-0 items-center overflow-hidden rounded-full p-0.5 ring-1 ring-inset transition-colors duration-200",
          checked
            ? "bg-primary ring-primary"
            : "bg-gray-200 ring-gray-300 group-hover:bg-gray-300",
          "group-focus-visible:ring-2 group-focus-visible:ring-primary group-focus-visible:ring-offset-2",
        )}
      >
        <span
          className={classNames(
            "h-4 w-4 rounded-full bg-white shadow transition-transform duration-200",
            checked ? "translate-x-full" : "translate-x-0",
          )}
        />
      </span>
    </button>
  );
}
